import { N, round, ceil } from './helpers.mjs';

export const MUCKAWAY = [
  // ====================== MUCK AWAY / GRAB LORRY ======================
  {
    slug: 'muck-away-grab',
    trade: 'groundworkers',
    name: 'Muck Away / Grab Lorry',
    blurb: 'Work out tonnage and how many grab lorry loads you need based on the material and lorry size. Densities and payloads use UK industry averages.',
    inputs: [
      { key: 'length', label: 'Length', unit: 'm', placeholder: '5' },
      { key: 'width', label: 'Width', unit: 'm', placeholder: '3' },
      { key: 'depth', label: 'Depth', unit: 'm', placeholder: '0.5' },
      {
        key: 'material',
        label: 'Material type',
        type: 'select',
        default: 'mixed',
        options: [
          { value: 'mixed', label: 'Mixed muck / spoil (1.8 t/m³)' },
          { value: 'hardcore', label: 'Hardcore / Type 1 (1.8 t/m³)' },
          { value: 'concrete', label: 'Broken concrete (2.4 t/m³)' },
          { value: 'tarmac', label: 'Tarmac / asphalt (2.3 t/m³)' },
          { value: 'clay-dry', label: 'Clay – dry (1.9 t/m³)' },
          { value: 'clay-wet', label: 'Clay – wet (2.1 t/m³)' },
          { value: 'soil', label: 'Topsoil / earth (1.5 t/m³)' },
          { value: 'soil-wet', label: 'Soil – wet (1.7 t/m³)' },
          { value: 'sand', label: 'Sand (1.5 t/m³)' },
          { value: 'gravel', label: 'Gravel / ballast (1.7 t/m³)' },
          { value: 'brick', label: 'Brick rubble (1.6 t/m³)' },
          { value: 'chalk', label: 'Chalk (1.4 t/m³)' },
        ],
      },
      {
        key: 'lorry',
        label: 'Grab lorry size',
        type: 'select',
        default: '32t',
        options: [
          { value: '32t', label: '8-wheeler – 32t GVW (≈16t payload)' },
          { value: '26t', label: '6-wheeler – 26t GVW (≈13t payload)' },
          { value: '18t', label: '4-wheeler – 18t GVW (≈10t payload)' },
          { value: 'tipper-7.5t', label: 'Tipper – 7.5t (≈3t payload)' },
        ],
      },
      { key: 'bulking', label: 'Bulking factor', unit: '%', placeholder: '30', default: 30 },
      { key: 'pricePerLoad', label: 'Price per load (optional)', unit: '£', placeholder: '0', default: 0 },
    ],
    compute: (v) => {
      const N = (x) => { const n = parseFloat(x); return Number.isFinite(n) ? n : 0; };
      const ceil = Math.ceil;
      const round = (x, d = 2) => Math.round(x * Math.pow(10, d)) / Math.pow(10, d);

      // Densities (tonnes per m³, in-situ / pre-bulk)
      const DENSITY = {
        mixed: 1.8, hardcore: 1.8, concrete: 2.4, tarmac: 2.3,
        'clay-dry': 1.9, 'clay-wet': 2.1, soil: 1.5, 'soil-wet': 1.7,
        sand: 1.5, gravel: 1.7, brick: 1.6, chalk: 1.4,
      };
      // Suggested bulking % when defaults are unclear
      const PAYLOAD = {
        '32t': 16, '26t': 13, '18t': 10, 'tipper-7.5t': 3,
      };

      const length = N(v.length), width = N(v.width), depth = N(v.depth);
      const inSituVol = length * width * depth;            // m³ before dig
      const bulkingPct = N(v.bulking) || 0;
      const looseVol = inSituVol * (1 + bulkingPct / 100); // m³ after dig
      const density = DENSITY[v.material] ?? 1.8;
      const tonnes = inSituVol * density;                  // weight doesn't change with bulking
      const payload = PAYLOAD[v.lorry] ?? 16;
      const loads = tonnes > 0 ? ceil(tonnes / payload) : 0;
      const cost = loads * N(v.pricePerLoad);

      const out = [
        { label: 'In-situ volume', value: round(inSituVol, 2), unit: 'm³' },
        { label: 'Loose volume (after bulking)', value: round(looseVol, 2), unit: 'm³' },
        { label: 'Tonnage', value: round(tonnes, 2), unit: 'tonnes' },
        { label: 'Grab loads required', value: loads, unit: `× ${v.lorry || '32t'}` },
      ];
      if (N(v.pricePerLoad) > 0) {
        out.push({ label: 'Estimated cost', value: '£' + round(cost, 2).toLocaleString(), unit: '' });
      }
      return out;
    },
  },


];
